import { render } from "./StockLocationModal.vue?vue&type=template&id=918b0d32"
import script from "./StockLocationModal.vue?vue&type=script&lang=js"
export * from "./StockLocationModal.vue?vue&type=script&lang=js"

import exportComponent from "/builds/weborigo-projects/vivien-vance/core-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__